import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  IdDiarioObrasEquipamento: number;
  IdDiarioObras: number;
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
};

export const initialFiltersValues: State = {
  IdDiarioObrasEquipamento: 0,
  IdDiarioObras: 0,
};

export const useDiarioObrasEquipamentoFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));